<script>
import Tahsilat from './tahsilat.vue'

export default {
  name: 'CreateModal',
  props:[
    "list",
    "opened"
  ],
  components:{
    Tahsilat
  },
  data() {
    return {
      options: [],
      form: {
        direction: 1
      },
      title:'',
      id:0,
      submitted: false,
      tahsilatData: {},
      isLoading: false,
        rows: [],
        totalRecords: 0,
        serverParams: {
          columnFilters: {},
          sort: [
            {
              field: '',
              type: '',
            },
          ],
          page: 1,
          perPage: 50,
        },
        currentPage: 0,
        selected: 0,
        pageLength: 0,
        paginationOptions: {
          enabled: true,
          dropdownAllowAll: false,
          perPage: 50,
          setCurrentPage: 1,
          perPageDropdown: [50, 100, 200],
          nextLabel: 'Sonraki',
          prevLabel: 'Önceki',
          rowsPerPageLabel: 'Kayıt Göster',
          ofLabel: 'of',
          pageLabel: 'sayfa', // for 'pages' mode
          infoFn: params => `Bulunduğun Sayfa ${params.currentPage}`,
      },
      selectOptions: {
        enabled: false,
        selectOnCheckboxOnly: false,
        selectionInfoClass: 'custom-class',
        selectionText: 'adet kayıt seçildi',
        clearSelectionText: 'seçimi iptal et',
        disableSelectInfo: false,
        selectAllByGroup: false,
      },
      columns: [
        {
          label: 'Ödemeyi Alan',
          field: "user_name",
          sortable:false,
        },
        {
          label: 'Tarih',
          field: this.transaction_date,
          sortable:false,
        },
         {
          label: 'Açıklama',
          field: 'main_explaine',
          sortable:false,
        },
        {
          label: 'Satış',
          field: 'borc',
          sortable:false,
        },
        {
          label: 'Komisyon',
          field: 'commission',
          sortable:false,
        },
        {
          label: 'Tahsilat',
          field: 'collect',
          sortable:false,
        },
        {
          label: 'Bakiye',
          field: 'balance',
          sortable:false,
        },
        {
          label: '#',
          field: '#',
          sortable:false,
        }
      ]
    }
  },
  watch:{
    opened(){
      // eslint-disable-next-line no-console
      console.log(this.list)
      this.id = this.list.id
      this.rows = []
     

      if(this.list.type == 'c'){
        this.title = 'Toplam Nakit Bakiye: ' + this.formatTL(this.list.cash) 
      }else{
         this.title = 'Toplam Kredi Bakiye: ' + this.formatTL(this.list.credit)
      }
      this.loadItems()
    }
  },
  methods: {
    transaction_date(props){
      return this.formatDate(props.transaction_date,"DD.MM.YYYY HH:MM")
    },

    updateParams(newProps) {
      this.serverParams = { ...this.serverParams, ...newProps }
    },
    onPageChange(params) {
      this.updateParams({ page: params.currentPage })
      this.loadItems()
    },
    onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage })
      this.loadItems()
    },
    onSortChange(params) {
      this.updateParams({
        sort: params,
      })
      this.loadItems()
    },
    onColumnFilter(params) {
      this.updateParams(params)
      this.loadItems()
    },
    loadItems() {
      this.getFromServer(this.serverParams).then(response => { 
        this.totalRecords = response.totalRecords
        this.pageLength = response.pageLength
        this.currentPage = response.currentPage
        this.rows = response.rows
      })
    },
    getFromServer() {
    return new Promise((resolve, reject) => {
        this.$http.post(`dealers/${this.id}/balances`, this.serverParams)
          .then(res => {
            resolve({
              rows: res.data.data,
              totalRecords: res.data.total,
              pageLength: res.data.last_page,
              currentPage: res.data.current_page,
            })
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    selectionChanged(a) {
      this.selected = a.selectedRows.length
    },
    onSearch(params) {
       this.updateParams(params)
        this.loadItems()
    },

    close(){
      this.$parent.$bvModal.hide('modal-scoped')
    },

    tahsilat(params){
      this.tahsilatData = params
      this.$parent.$bvModal.show('tahsilat_modal')
    }
  },
};
</script>

<template>
  <b-modal id="modal-balance" size="lg" :title="title"  no-close-on-backdrop hide-footer>
    <Tahsilat :data="tahsilatData" />
    <div class="row">
      <div class="col-12">
        <div class="card">
             <vue-good-table
                mode="remote"
                :total-rows="totalRecords"
                :columns="columns"
                :rows="rows"
                :search-options="{
                    enabled: false
                  }"
                @on-search="onSearch"
                :select-options="selectOptions"
                :pagination-options="paginationOptions"
                :is-loading.sync="isLoading"
                @on-selected-rows-change="selectionChanged"
                @on-page-change="onPageChange"
                @on-sort-change="onSortChange"
                @on-column-filter="onColumnFilter"
                @on-per-page-change="onPerPageChange">
                <template slot="loadingContent">
                  <div>Yükleniyor</div>
                </template>
                <template
                  slot="table-row"
                  slot-scope="props"
                >
                  <span
                    v-if="props.column.field === '#'"
                    class="text-nowrap"
                  >
                     <ul class="list-inline font-size-20 contact-links mb-0">
                        <li class="list-inline-item">
                          <a  @click="tahsilat(props.row)">
                            <i class="mdi mdi-cash"></i>
                          </a>
                        </li>
                      </ul>
                  </span>
                </template>
            </vue-good-table>
        </div>
      </div>
    </div>
</b-modal>
</template>